<template>

  <div>

    <Hero />

    <Block1 />

    <Bio />

    <Videowall />

    <Songs />

    <Hero2 />

    <ContactForm />

    <Faq />

  </div>

</template>

<script>
import Hero from "../components/Hero.vue";
import Hero2 from "../components/Hero2.vue";
import Videowall from "../components/Videowall.vue";
import Block1 from "../components/Block1.vue";
import Songs from "../components/Songs.vue";
import Bio from "../components/Bio.vue";
import Faq from "../components/Faq.vue";
import ContactForm from "../components/ContactForm.vue";

export default {
  components: {
    Hero: Hero,
    Hero2: Hero2,
    Videowall: Videowall,
    Block1: Block1,
    Songs: Songs,
    Bio: Bio,
    Faq: Faq,
    ContactForm: ContactForm
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
@media (max-width: 900px) {
  /* Piilota komponentti alle 800px leveydellä */
  .hidden {
    display: none !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Main.vue